// @flow
import React from 'react';
import cx from 'classnames';
import Partnerpone from '../Partnerpone/Partnerpone';
import './FakePartnerCard.scss';

type Props = {
  oneColumn?: boolean,
};

const FakePartnerCard = ({ oneColumn }: Props) => (
  <Partnerpone duration={100}>
    <div className={cx('PartnerCard FakePartnerCard', { 'one-column': oneColumn })}>
      <div className="thumbnail-wrapper">
        <img
          src="https://images.cacheby.com/placeholder.png?s=600x316&t=crop&q=82&f=webp"
          alt="thumbnail"
        />
      </div>
    </div>
  </Partnerpone>
);

FakePartnerCard.defaultProps = {
  oneColumn: false,
};

export default FakePartnerCard;



// WEBPACK FOOTER //
// ./src/components/common/FakePartnerCard/FakePartnerCard.js